<template>
  <b-form @submit.prevent="evOnSubmit">
    <b-row>
      <b-col>
        <v-text-field
          :loading="loading"
          :disabled="step > 0"
          dense
          outlined
          label="E-mail"
          placeholder="Informe seu e-mail"
          hide-details
          ref="autofocus"
          v-model="email"
        />
      </b-col>
    </b-row>
    <b-row v-if="step == 1" class="signin-scroll-rest-homes">
      <b-col>
        <h6>EMPRESA:</h6>
        <b-form-group>
          <template v-for="rest_home in rest_homes">
            <b-form-radio
              :key="rest_home.id"
              :disabled="step != 1 || loading"
              v-if="step == 1 || rest_home_id == rest_home.id"
              v-model="rest_home_id"
              :value="rest_home.id"
            >
              {{ rest_home.name }}
            </b-form-radio>
          </template>
        </b-form-group>
      </b-col>
    </b-row>
    <errors-messages :errors="errors" class="mb-0" />
    <success-message :message="timeoutMessage" />
    <b-row v-if="step < 2">
      <b-col class="pt-0">
        <v-btn
          v-if="step == 0"
          type="submit"
          class="btn-add btn-block"
          :disabled="loading"
        >
          <i class="fas fa-check mr-2 text-twenty" />
          {{ loading ? "BUSCANDO" : "PROSSEGUIR" }}
        </v-btn>
        <v-btn
          v-if="step == 1"
          type="submit"
          class="btn-save btn-block"
          :disabled="loading"
        >
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "SOLICITANDO" : "SOLICITAR" }}
        </v-btn>
      </b-col>
    </b-row>
    <b-row v-if="step < 2" align-h="between">
      <b-col cols="auto">
        <v-btn
          text
          class="text-thirteen"
          :disabled="loading"
          @click="$router.push({ name: 'sign-in' })"
        >
          <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
        </v-btn>
      </b-col>
      <b-col cols="auto">
        <v-btn
          text
          class="text-thirteen"
          :disabled="loading"
          @click="$emit('recover-with-code')"
        >
          TENHO UM CÓDIGO
        </v-btn>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import SuccessMessage from "../Components/SuccessMessage.vue";
export default {
  name: "RequestCode",
  components: { ErrorsMessages, SuccessMessage },
  props: {
    timeoutMessage: String,
  },
  data() {
    return {
      errors: [],
      loading: false,

      step: 0,
      email: "",
      rest_homes: [],
      rest_home_id: undefined,
    };
  },
  mounted() {
    this.$refs.autofocus.focus();
  },
  methods: {
    async evOnSubmit() {
      if (this.step == 0) this.getRestHomes();
      else if (this.step == 1) this.demandEmail();
    },

    async getRestHomes() {
      try {
        this.loading = true;

        let params = { email: this.email };
        let response = await api.get(
          "/rest-home/user/new-password/rest-homes-by-email",
          { params }
        );
        let { error, errors, rest_homes } = response.data;

        if (error) {
          this.errors = errors;
          this.rest_homes = [];
        } else {
          this.rest_homes = rest_homes;
          this.step = 1;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async demandEmail() {
      try {
        this.loading = true;

        let params = { rest_home_id: this.rest_home_id, email: this.email };
        let response = await api.post("/rest-home/user/new-password", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.step = 2;
          toast(message, "success");
          this.$emit("requested");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.signin-scroll-rest-homes {
  overflow: scroll;
  max-height: 50vh;
}
</style>
